






















import { Component, Vue, Prop } from "vue-property-decorator";
import { GetCenter } from "@/request/sjzx";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "./components/nav-left.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class ZbsjkSelect extends Vue {
  private centers: any[] = [];
  /**
   * @description 获得中心列表
   */
  private fetchCenters() {
    GetCenter(this).then((data: any) => {
      this.centers = data;
    });
  }
  /**
   * @description 跳转
   */
  private jump(center) {
    this.$router.push({
      path: "/main/sjzx/zbsjk-list",
    });
    localStorage.setItem("center", JSON.stringify(center));
    const filters = {
      hospital_ids: [],
      范围: [],
      search: "",
      性别: "",
      开始年龄: "",
      结束年龄: "",
      开始时间: "",
      结束时间: "",
      年龄段: [],
      timeWay: "",
      time: [],
      条件: "",
      研究指标: [],
      自定义年龄: [false],
      时间段: "",
      自定义时间段: [false, []],
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      pageSize: 10,
      cSortField: "更新时间",
      cSortValue: "0",
      ifPrimarySearched: false,
    };

    switch (center["center"]) {
      case "临床科室数据中心":
        break;
      case "治未病数据中心":
        filters["体重"] = [];
        filters["单位"] = "";
        filters["备孕女性体质辨识"] = [];
        filters["孕期女性体质辨识"] = [];
        filters["产后女性体质辨识"] = [];
        filters["老年人体质类型"] = [];
        filters["儿童体质类型"] = [];
        filters["体质辨识"] = [];
        filters["四诊合参体质辨识"] = [];
        filters["慢性病"] = [];
        break;
      case "名中医传承数据中心":
        break;
      case "中医影像数据中心":
        break;
    }
    localStorage.setItem("zbsjkFilters", JSON.stringify(filters));
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchCenters();
  }
}
